import { Reducer } from "redux";

import { UpdateUserDetailsResponse } from "../models/api/MyAccount";
import { UserDetailsDispatchTypes } from "../models/dispatchTypes/MyAccount";
import { UserDetailsActionDispatchTypes } from "../constants/MyAccount";

const initialState: UpdateUserDetailsResponse = {
  loading: false,
  response: {
    providerPortalUser: {
      userId: "",
      userName: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      status: "",
      twoFactorEnabled: true,
      accessFailedCount: true,
      registrationDate: "",
      registrationSource: "",
      approver: null,
      mfaId: 0,
      mfaType: "",
      roleId: "",
      roleType: "",
      userCreated: "",
    },
    userProviderList: [],
  },
  error: null,
};

const UpdateUserDetailsReducer: Reducer<
  UpdateUserDetailsResponse,
  UserDetailsDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case UserDetailsActionDispatchTypes.UPDATE_USER_DETAILS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case UserDetailsActionDispatchTypes.UPDATE_USER_DETAILS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case UserDetailsActionDispatchTypes.UPDATE_USER_DETAILS_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case UserDetailsActionDispatchTypes.UPDATE_USER_DETAILS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default UpdateUserDetailsReducer;
